function pre_payment_topup_response (popup_contents) {
    $('.popup-ajax').find('.pre-payment-topup_user-id').val(popup_contents.user_id);
}

export {pre_payment_topup_response}